import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { BASELINE } from "../../util";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "react-hot-toast";
import SurveyModal from "../dashboard/sat_survey";
const DevHero = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="wrapper relative">
      <div className="contain">
        <img
          src="/hero.png"
          className="w-full object-cover min-h-[500px] rounded-2xl"
          alt=""
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-start items-center flex-col gap-8 text-center w-full">
          <div className="flex gap-4"> {/* Add this line */}
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Open Survey
            </button>

     

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devpsat/1">
                DEV PSAT
              </Link>
            </motion.div>

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devpsat89/1">
                DEV PSAT 8/9
              </Link>
            </motion.div>

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devpsat10/1">
                DEV PSAT 10
              </Link>
            </motion.div>

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devact/1">
                DEV ACT
              </Link>
            </motion.div>

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devapcalc/1">
                DEV AP.
              </Link>
            </motion.div>

            <motion.div
              whileTap={{ scale: 0.97 }}
              className="text-white w-[190px] h-[60px] grid place-items-center rounded text-xl font-bold font-archivo"
              style={{
                background: 'linear-gradient(to right, #001F3F, #000f3f)'
              }}
            >
              <Link to="/devapcalc/1">
                SAT Course
              </Link>
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default DevHero;